class ProductVariants extends HTMLElement {
    constructor() {
      super();
        // VARIABLES
        this.variantJson = document.querySelector('[data-variant-json]');
        this.variantsObject = JSON.parse(this.variantJson.innerHTML);
        console.log(this.variantsObject);
        this.variantInputs = this.querySelectorAll('[product-data-variant-input]');
        this.addToCartBtn = document.querySelector('.origin-add-to-cart');
        this.submitBtn = document.querySelector('.product-single__form .add-to-cart');
        this.productForm = document.querySelector('.product-single__form');
        this.optionsWrapper = this.querySelectorAll('.product-variant-wrapper');
        this.formSelect = document.querySelector('.product-single__form select[data-product-select]');
        this.outOfStockBtn = document.querySelector('#stock-hint-form-btn');


         // Price-related
         this.priceWrapper = document.querySelector('[data-product-price-wrap]');
         this.comparePriceA11y =  document.querySelector('[data-compare-price-a11y]');
         this.comparePrice = document.querySelector('[data-compare-price]');
         this.price = document.querySelector('[data-product-price]');
         this.priceA11y = document.querySelector('[data-a11y-price]');


        // EVENTS
        this.variantInputs.forEach((input)=>{
            input.addEventListener('change',(e)=>{
                this.selectVariant(e.target);
            })
        })

        this.addToCartBtn.addEventListener('click',(e)=>{
            e.preventDefault();
            this.addToCart();
        })

        // INIT 
        this.getUnvalaibleOptions();

        this.variantsObject.forEach((variant)=>{
            let containUnavalaibleVariant = false;
            if(!variant.available){
                containUnavalaibleVariant = true;
            }

            if(containUnavalaibleVariant && this.outOfStockBtn){
                this.outOfStockBtn.classList.add('btn-show');
            }
        })

        this.selectOneOptionProduct();
    }

    selectOneOptionProduct(){
    
        this.optionsWrapper.forEach((block=>{
            let elements = block.querySelectorAll('[product-data-variant-input]');
            if(elements.length == 1){
                if(!elements[0].classList.contains('disabled')){
                    elements[0].checked = true;
                }
            }
        }))
    }

    setAvailableVariant(index, value){
        let secondOption;
        if(index == 'option1'){
            secondOption = 'option2'
        }else if(index == 'option2'){
            secondOption = 'option1'
        }
        this.variantsObject.forEach((variant)=>{
            if(variant[index] == value){
                let secondOptionValue = variant[secondOption];
                let secondOptionField = this.querySelector(`[data-index="${secondOption}"][data-value="${secondOptionValue}"]`);
                
                if(variant.available){
                    secondOptionField.querySelector('input').disabled = false;
                    secondOptionField.querySelector('input').classList.remove('disabled');
                    secondOptionField.querySelector('label').classList.remove('disabled');
                }else{
                    secondOptionField.querySelector('input').disabled = true;
                    secondOptionField.querySelector('input').classList.add('disabled');
                    secondOptionField.querySelector('label').classList.add('disabled');
                }
            }
        })
    }

    hideNotExistingOption(index,value){
        let secondOption;
        if(index == 'option1'){
            secondOption = 'option2'
        }else if(index == 'option2'){
            secondOption = 'option1'
        }

        document.querySelectorAll(`input[data-index="${secondOption}"]`).forEach((input)=>{
            let secondValue = input.value;
            let variantExist = false;
            this.variantsObject.forEach((variant)=>{
                if(variant[index] == value && variant[secondOption] == secondValue){
                    variantExist = true;
                }
            })

            if(!variantExist){
                input.disabled = true;
                input.classList.add('disabled');
                input.parentNode.querySelector('label').classList.add('disabled');
            }
        })
    }

    getUnvalaibleOptions(){
        this.variantInputs.forEach((input)=>{
            let index = input.getAttribute('data-index');
            let value = input.value;
            let optionAvailable = false;

            this.variantsObject.forEach((variant)=>{
                if(variant[index] == value){
                    if(variant.available){
                        optionAvailable = true;
                    }
                }
            })
            console.log(`index ${index} - ${value} - ${optionAvailable}`);
            if(!optionAvailable){
                input.disabled = true;
                input.classList.add('disabled');
                input.parentNode.querySelector('label').classList.add('disabled');
            }
        })
    }

    changeVariantId(options){
        if(options[1] == undefined){
            options[1] == null
        }

        this.variantsObject.forEach((variant)=>{
            if(options[0] == variant.option1 && options[1] == variant.option2){
                let id = variant.id;
                this.formSelect.value = id;
                this.changeUrl(id);
                this.changeVariantImage(id);
                this.changePrice(id);
            }
        })
    }

    selectVariant(input){
        let value = input.value;
        let optionWrapper = input.parentNode.parentNode.parentNode.parentNode;
        let options = [];
        let allSelected = true;

        if(optionWrapper.querySelector('.variant-error')){
            optionWrapper.querySelector('.variant-error').remove();
        }

        if(this.optionsWrapper.length > 1){
            let currentIndex = input.getAttribute('data-index');
            this.setAvailableVariant(currentIndex,value);
            this.hideNotExistingOption(currentIndex,value);
        }

        this.optionsWrapper.forEach((block)=>{
            if(!block.querySelector('[product-data-variant-input]:checked')){
                allSelected = false;
                return false;
            }else{
                options.push(block.querySelector('[product-data-variant-input]:checked').value);
            }
        })
        
        if(allSelected){
            this.changeVariantId(options);
        }
    }

    getVariant(id){
        let result;
        this.variantsObject.forEach((variant)=>{
            if(variant.id == id){
                result = variant;
            }
        })

        return result;
    }

    changeUrl(id){
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + id;
        window.history.replaceState({path: newurl}, '', newurl);
        
    }

    changePrice(id){
        let variant = this.getVariant(id);

        if(variant){
            let price = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
            this.price.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);


               // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            this.comparePrice.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
            this.priceWrapper.classList.remove('hide');
            this.price.classList.add('sale-price');
            this.comparePriceA11y.setAttribute('aria-hidden', 'false');
            this.priceA11y.setAttribute('aria-hidden', 'false');
          } else {
            if (this.priceWrapper) {
              this.priceWrapper.classList.add('hide');
            }
            this.price.classList.remove('sale-price');
            if (this.comparePriceA11y) {
              this.comparePriceA11y.setAttribute('aria-hidden', 'true');
            }
            this.priceA11y.setAttribute('aria-hidden', 'true');
          }
        }
    }


    changeVariantImage(id){
        let variant = this.getVariant(id);
        
        if(variant && variant.featured_image){
            var newImage = document.querySelector('.product__photos .product__thumb[data-id="' + variant.featured_media.id + '"]');
            var imageIndex = newImage.dataset.index;
            
             // If there is no index, slider is not initalized
            if (typeof imageIndex === 'undefined') {
                return;
            }
            // Go to that variant image's slide
            let flkty = Flickity.data('.product-slideshow')
            
            if (flkty) {
                flkty.select(imageIndex)
            }
        }
    }

    checkErrors(){
        let error = false;

        if(this.optionsWrapper.length > 0){
            this.optionsWrapper.forEach((block)=>{
                if(!block.querySelector('[product-data-variant-input]:checked')){
                    error = true;

                    if(!block.querySelector('.variant-error')){
                        let optionName = block.getAttribute('data-option-name');
                        
                        let errorDiv = document.createElement('div');
                        errorDiv.classList.add('variant-error');
                        if(block.getAttribute('data-error-text')){
                            errorDiv.textContent = block.getAttribute('data-error-text');
                        }else{
                            errorDiv.textContent = `Wähle eine ${optionName} aus, bevor du den Artikel in den Warenkorb legst.`;
                        }
                        block.insertAdjacentElement("beforeend", errorDiv);
                        
                    }
                }
            })
        }

        return error;
    }

    addToCart(){
        if(this.checkErrors()){
            let y = document.querySelector('.product-variants-block').getBoundingClientRect().top + window.pageYOffset - 200;
            if(y){
                window.scrollTo({
                    top: y,
                    left: 0,
                    behavior: "smooth",
                });
            }
           
            return false;
        }else{
            this.productForm.submit();
        }
    }
  }
  
customElements.define('product-variants', ProductVariants);



















